import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'script-tag',
    templateUrl: './script-tag.component.html',
    standalone: false
})
export class ScriptTagComponent {
  @Input() src: string;
  @Input() type: string;
  @ViewChild('script', { static: true }) script: ElementRef;

  convertToScript() {
    let element = this.script.nativeElement;
    let script = document.createElement('script');
    script.type = this.type ? this.type : 'text/javascript';
    if (this.src) {
      script.src = this.src;
    }
    if (element.innerHTML) {
      script.innerHTML = element.innerHTML;
    }
    let parent = element.parentElement;
    parent.parentElement.replaceChild(script, parent);
  }

  ngAfterViewInit() {
    this.convertToScript();
  }
}